import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form, InputGroup, Modal } from "@themesberg/react-bootstrap";
import Joi from "joi";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import Datetime from "react-datetime";
import { useTranslation } from "react-i18next";
import { returnUserReadableDate } from "../../utils/datetime";
import { generateRandomId } from "../../utils/string";
import { returnValidationErrorMessages } from "../../utils/validation";
import DropdownComponent from "./Dropdown";
import { getAdditionalParcelInInvoiceToReschedule } from "../../utils/parcels";

const rescheduleSchema = Joi.object({
    targetBranch: Joi.string().required(),
    date: Joi.date().required(),
    remarks: Joi.string().required()
});

const RescheduleModal = (props) => {
    const {
        showModal,
        closeModal,
        onConfirm,
        selectedParcelId,
        pageStatus,
        targetDropdownOptions,
        disableTargetDropdown = true
    } = props;
    const [formErrors, setFormErrors] = useState({});
    const pageParcels = useSelector((state) => state.parcels[pageStatus] || {});
    const selectedParcel = pageParcels[selectedParcelId] || {};
    const [data, setFormData] = useState({
        remarks: selectedParcel.remarks || ""
    });
    const configData = useSelector((state) => state.user.config || {});
    const { t } = useTranslation();
    const [extraParcelIds, setExtraParcelIds] = useState({});

    const handleConfirmClick = async () => {
        const formData = {
            ...data,
            targetBranch: selectedParcel?.returnScanWarehouse,
            remarks: data.remarks || selectedParcel?.remarks
        };
        const { error: formErrors = {}, value: formValue } = rescheduleSchema.validate(formData, {
            abortEarly: false
        });
        const {
            details = {}
        } = formErrors;
        if (details?.length > 0) {
            const validationErrorMessages = returnValidationErrorMessages(details);
            setFormErrors(validationErrorMessages);
        } else {
            onConfirm({ ...formValue, parcelObjectId: selectedParcelId, extraParcelIds })
        }
    };
    const additionalParcelToChoose = getAdditionalParcelInInvoiceToReschedule(configData?.productCategoryToCheckForReschedule || [], pageParcels, selectedParcel);
    return (
        <Modal id={generateRandomId()} as={Modal.Dialog} centered show={showModal} onHide={closeModal}>
            <Modal.Header>
                <Modal.Title className="h6">{t("Reschedule Parcel")}</Modal.Title>
                <Button variant="close" aria-label="Close" onClick={closeModal} />
            </Modal.Header>
            <Modal.Body>
                {(additionalParcelToChoose?.length > 0) && (
                    <Form.Group className="mb-4">
                        <Form.Label>{t("Choose Extra Outdoor / Indoor Unit also")}</Form.Label>
                        {additionalParcelToChoose?.map(extraParcel => {
                            return (
                                <Form.Check
                                    defaultValue={false}
                                    onChange={(event) => {
                                        extraParcelIds[extraParcel.objectId] = event.target.checked;
                                        setExtraParcelIds(extraParcelIds);
                                    }}
                                    label={`${extraParcel.product}. Serial No: ${extraParcel.serialNo}`}
                                    id={extraParcel.objectId}
                                    htmlFor={extraParcel.objectId} />
                            )
                        })}
                    </Form.Group>
                )}
                <Form.Group className="mb-4">
                    <Form.Label className={formErrors["targetBranch"]?.length > 0 ? "text-danger" : ""}>{t("Choose Target Branch")}</Form.Label>
                    <DropdownComponent
                        disabled={disableTargetDropdown}
                        onChange={(option) => {
                            setFormData(oldData => ({
                                ...oldData,
                                targetBranch: option.value
                            }))
                        }}
                        options={targetDropdownOptions}
                        placeholder={t(selectedParcel?.returnScanWarehouse)}
                    />
                </Form.Group>
                {formErrors["targetBranch"]?.length > 0 && (
                    <Form.Control.Feedback type="invalid">{formErrors["targetBranch"]}</Form.Control.Feedback>
                )}
                <Form.Group className="mb-4">
                    <Form.Label>{t("Choose Delivery Date")}</Form.Label>
                    <Datetime
                        timeFormat={false}
                        closeOnSelect={true}
                        onChange={(value) => {
                            setFormData(oldData => ({
                                ...oldData,
                                date: new Date(value)
                            }))
                        }}
                        renderInput={(props, openCalendar) => (
                            <InputGroup>
                                <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} className="icon icon-xs" /></InputGroup.Text>
                                <Form.Control
                                    isInvalid={formErrors["date"]?.length > 0}
                                    required
                                    type="text"
                                    value={returnUserReadableDate(data.date)}
                                    placeholder="Select delivery date"
                                    onFocus={openCalendar} />
                                {formErrors["date"]?.length > 0 && (
                                    <Form.Control.Feedback type="invalid">{formErrors["date"]}</Form.Control.Feedback>
                                )}
                            </InputGroup>
                        )} />
                </Form.Group>
                <Form.Group className="mb-4">
                    <Form.Label>{t("Reason")}</Form.Label>
                    <Form.Control
                        isInvalid={formErrors["remarks"]?.length > 0}
                        required
                        type="text"
                        defaultValue={data.remarks || selectedParcel?.remarks}
                        onChange={(event) => {
                            const remarks = event.target.value;
                            setFormData(oldData => ({
                                ...oldData,
                                remarks
                            }))
                        }}
                        placeholder={t("Reason to Reschedule")} />
                    {formErrors["remarks"]?.length > 0 && (
                        <Form.Control.Feedback type="invalid">{formErrors["remarks"]}</Form.Control.Feedback>
                    )}
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleConfirmClick}>
                    {t("Rechedule")}
                </Button>
                <Button variant="link" className="text-gray ms-auto" onClick={closeModal}>
                    {t("Cancel")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
export default RescheduleModal;